import { Injectable } from '@angular/core';
import { ClientSharedUtilityStorageModule } from './storage.module';

@Injectable({
    providedIn: ClientSharedUtilityStorageModule,
})
export class LocalStorageService {
    private readonly defaultExpiration = 24 * 60 * 60 * 1000; // 1 day in milliseconds

    set(
        key: string,
        value: string,
        expirationInMs: number = this.defaultExpiration
    ): void {
        const expirationDate = new Date().getTime() + expirationInMs;
        const item = {
            value,
            expiration: expirationDate,
        };
        localStorage.setItem(key, JSON.stringify(item));
    }

    get<T>(key: string): T | null {
        const itemStr = localStorage.getItem(key);

        if (!itemStr) {
            return null;
        }

        const item = JSON.parse(itemStr);

        if (new Date().getTime() > item.expiration || !item.expiration) {
            this.remove(key);
            return null;
        }

        return JSON.parse(item.value) ?? null;
    }

    remove(key: string): void {
        localStorage.removeItem(key);
    }

    clear(): void {
        localStorage.clear();
    }
}
